import React from 'react';
import PropTypes from 'prop-types';

const CustomerMessage = ({ headoffice }) => {
    if (!headoffice.customer_message) {
        return null;
    }
    return (
        <div
            data-view="customer-message"
            className="m2g-customer-message m2g-list-cell m2g-list-cell--without-bottom-border m2g-list-cell--with-top-border"
        >
            <div
                className="m2g-list-cell__content m2g-customer-message-content m2g-custom-html"
                dangerouslySetInnerHTML={{
                    __html: headoffice.customer_message_html,
                }}
            />
        </div>
    );
};

CustomerMessage.propTypes = {
    headoffice: PropTypes.shape({
        customer_message: PropTypes.string.isRequired,
        customer_message_html: PropTypes.string.isRequired,
    }).isRequired,
};

export default CustomerMessage;
